import { render, staticRenderFns } from "./CCMObservationEdit.vue?vue&type=template&id=67cd1b44"
import script from "./CCMObservationEdit.vue?vue&type=script&lang=js"
export * from "./CCMObservationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports